/** Contact page copy and the demo-request form. */
import contactPicture from '@/assets/images/contact/contact-en.webp'
import { PRIVACY_EMAIL, SITE_EMAIL } from '@/data/links'

export const CONTACT = {
  eyebrow: 'Contact',
  title: "Let's set up MeetNPlan for your office",
  text: "Tell us a little about your team and we'll get back to you within one working day to book a demo.",
  // Drawn per language: the Arabic copy has its own, mirrored picture.
  image: contactPicture,
  imageAlt: 'A demo request arriving in MeetNPlan, with the reply on its way',
  emails: {
    title: 'Or email us',
    items: [
      { label: 'Questions and demos', email: SITE_EMAIL },
      { label: 'Privacy and your data', email: PRIVACY_EMAIL },
    ],
  },
}

export const FORM = {
  title: 'Book a demo',
  subtitle: 'We reply within one working day.',
  fields: {
    name: { label: 'Name', placeholder: 'Full name' },
    email: { label: 'Work email', placeholder: 'name@company.com' },
    company: { label: 'Company', placeholder: 'Company name' },
    phone: { label: 'Phone', placeholder: '+966' },
    message: {
      label: 'Message',
      hint: '· optional',
      placeholder: 'Tell us about your rooms, branches or anything else',
    },
  },
  size: {
    label: 'Team size',
    options: ['1–10', '11–50', '51–200', '200+'],
    default: '11–50',
  },
  notice: {
    before: 'We use these details only to answer your request. See our ',
    link: { label: 'privacy policy', href: '/privacy' },
    after: '.',
  },
  submit: 'Send request',
  errors: {
    missing: 'Please fill in name, work email, company and phone.',
    failed: `Something went wrong. Please try again, or email us directly.`,
  },
  sent: {
    title: (firstName) => `Thanks, ${firstName || 'there'}`,
    // Shown when the request was posted to the contact endpoint.
    posted: (email) =>
      `We've got your request and will email ${email} within one working day.`,
    // Shown when no endpoint is set and the visitor's mail app took over.
    mailed:
      'Your email app has opened with your request. Press send and we will reply within one working day.',
    again: 'Send another',
  },
  mailSubject: (company) => `Demo request: ${company}`,
}
